import axios from 'axios';

import {
  CalculatedWorkDemand,
  WorkDemand,
  WorkDemandRow
} from 'components/types';

import { AggregateOn } from 'components/enums';

import { WORK_DEMAND, WORK_DEMAND_CALCULATED } from '../endpoints';

type GetWorkDemandOptions = {
  scenarioId: number;
  year: number;
  aggregateOn?: AggregateOn;
};

export interface SaveWorkDemandPayload {
  costCenterId: number;
  description: string;
  quantity: number;
  directClientHours: number;
  indirectClientHours: number;
  organisationHours: number;
  unit: string;
  timeframe: {
    from: string;
    to: string;
  };
  functionId?: number;
}

type SaveWorkDemandOptions = {
  workDemandId?: number;
  scenarioId: number;
  payload: SaveWorkDemandPayload;
};

export const getCalculatedWorkDemand = (options: GetWorkDemandOptions) => {
  const { scenarioId, year, aggregateOn } = options;
  const params = {
    year,
    aggregateOn: aggregateOn
  };

  return axios.get<CalculatedWorkDemand>(`${WORK_DEMAND_CALCULATED}`, {
    params,
    pathParams: { scenarioId }
  });
};

export const getWorkDemand = (options: GetWorkDemandOptions) => {
  const { scenarioId, year, aggregateOn } = options;

  return axios.get<WorkDemand>(WORK_DEMAND, {
    params: {
      year,
      aggregateOn: aggregateOn
    },
    pathParams: { scenarioId }
  });
};

export const deleteWorkDemand = (idsList: number[]) => {
  const params = {
    idsList: idsList.join(',')
  };
  return axios.delete(WORK_DEMAND, { params });
};

export const createWorkDemand = ({
  payload,
  scenarioId
}: SaveWorkDemandOptions) =>
  axios.post<WorkDemandRow>(WORK_DEMAND, payload, {
    pathParams: { scenarioId }
  });

export const updateWorkDemand = ({
  payload,
  scenarioId,
  workDemandId
}: SaveWorkDemandOptions) =>
  axios.put<WorkDemandRow>(`${WORK_DEMAND}/${workDemandId}`, payload, {
    pathParams: { scenarioId }
  });
